import React, { useCallback } from 'react';
import { Icon, Tappable } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  areAppliedFiltersPresentSelector,
  resetFilters,
  resetSbatGroupBulkUpdate,
  setSbatGroupBulkUpdateFilterModalState,
} from 'features/classCreation';
import SbatGroupFilterChips from '../SbatGroupFilterChips';

export default function FilterSection() {
  const dispatch = useDispatch();
  const areAppliedFiltersPresent = useSelector(
    areAppliedFiltersPresentSelector
  );

  const handleAddFiltersClick = useCallback(() => {
    dispatch(setSbatGroupBulkUpdateFilterModalState(true));
  }, [dispatch]);

  const handleClearFiltersClick = useCallback(() => {
    batch(() => {
      dispatch(resetFilters());
      dispatch(resetSbatGroupBulkUpdate());
    });
  }, [dispatch]);

  if (areAppliedFiltersPresent) {
    return (
      <div className="m-t-xxs">
        <SbatGroupFilterChips />
        <Tappable
          noHighlight
          onClick={handleAddFiltersClick}
          className="primary m-l-xs h5 bold"
        >
          Add
        </Tappable>
        <Tappable
          noHighlight
          onClick={handleClearFiltersClick}
          className="primary m-l-xs h5 bold"
        >
          Clear filters
        </Tappable>
      </div>
    );
  } else {
    return (
      <div className="m-t-xxs">
        <Tappable
          className="btn btn-outlined btn-primary p-xxs"
          onClick={handleAddFiltersClick}
        >
          <Icon
            name="add"
            className="m-r-xxs h2 cursor"
          />
          Add Filters
        </Tappable>
      </div>
    );
  }
}
